'use client';

import { useEffect } from 'react';
import { CONFIG } from '@frameio/config';
import { useMeQuery } from '@frameio/graphql-client/generated';
import { Storage } from '@frameio/utils';
import { Box, Text, theme } from '@frameio/vapor';
import { IconWarning } from '@frameio/vapor-icons';

const ERROR_POLL_INTERVAL = 2000;

export const storage = new Storage<{
  lastVpnErrorRedirect?: number;
}>();

export const VpnError = (props?: { reloadOnceConnected?: boolean }) => {
  const { data } = useMeQuery({
    pollInterval: ERROR_POLL_INTERVAL,
    skip: !CONFIG.requiresVpnConnection || !props?.reloadOnceConnected,
  });

  useEffect(() => {
    if (!data) return;
    const lastRedirectMs = storage.get('lastVpnErrorRedirect', 0)!;
    const now = Date.now();
    if (now - lastRedirectMs > ERROR_POLL_INTERVAL) {
      storage.set('lastVpnErrorRedirect', now);
      window.location.reload();
    }
    // Only fire when a new completed result arrives (mirrors `onCompleted`).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Box
      alignItems="center"
      backgroundColor="panel"
      borderRadius={8}
      display="flex"
      flexDirection="column"
      height="100%"
      justifyContent="center"
      padding={32}
      textAlign="center"
      width="100%"
    >
      <IconWarning
        aria-label="VPN Error"
        color={theme.colors.icon.interactive.error}
      />
      <Text variant="header">VPN Connection Error</Text>
    </Box>
  );
};
